import { ConfigSection } from '@components-fabric';
import { layoutWorkspace } from '../_common/layout.workspace';
import { DashboardScreen } from './screens.dashboard';
import { PageTable } from '@components-common/layouts';
import { AnalyticsScreen } from './screens.analytics';

/**
 * Configuration Object: userSection
 * 
 * This object contains the configuration for the user section.
 * It includes roles, layout, URL parameters, columns, and actions.
 */
const userSection: any = {
  id: 'users',
  title: 'Users',
  path: 'users',
  tmp: 'index',
  screens: [
    {
      id: 'index',
      columns: [
        'initials',
        'colFirstAndLastName',
        {
          id: 'custom',
          text: 'Display Name',
          dataField: 'displayName',
          filterObject: { placeHolder: 'displayName' },
          order:111,
        },
        'email',
        'role',
      ] as any,
      roles: ['STUDY_DIRECTOR', 'LECTURER'],
      tmp: 'index',
      path: '.',
      left: [],
      right: [],
      Component: PageTable,
      source: 'usersms/users',
      actions: [],
    },
  ],
};

/**
 * Configuration Object: managementAreaSection
 * 
 * This object contains the configuration for the management area section.
 * It includes roles, layout, URL parameters, columns, and actions.
 */
export const managementAreaSection: ConfigSection = {
  id: 'management',
  layout: layoutWorkspace,
  protected: false,
  tmp: 'index',
  screens: [
    {
      id: 'dashboard',
      path: '',
      tmp: 'custom',
      roles: ['STUDY_DIRECTOR', 'LECTURER'],
      Component: DashboardScreen,
    },
    {
      id: 'analytics',
      path: 'analytics',
      roles: ['STUDY_DIRECTOR', 'LECTURER'],
      Component: AnalyticsScreen,
    },
  ],
  sections: [userSection],
};
